import { useState } from 'react';
import './Buttons.css';
import { Roles } from '../../shared/enums';
import { CallEnd } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Publisher, Session } from 'openvidu-browser-v2compatibility';
import { saveEventHistory, registerInspectionHistory } from '../../services/legacyService';
import ModalDialogComponent from '../FeedbackComponent/Feedback';

export default function PowerOffButton(props: {
  session: Session;
  sessionId: string;
  publisher: Publisher;  
  insuranceId: string;
  userId: string;
}) {
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const navigate = useNavigate();

  async function confirmLeaveSession() {
    setIsOpenDialog(false);

    try {
      const historyMessage = 'Segurado/usuário clicou no botão de desligar a chamada.';
      const historyWrites: Promise<unknown>[] = [saveEventHistory(historyMessage, props.publisher.session.sessionId)];

      if (props.userId) {
        historyWrites.push(
          registerInspectionHistory({
            inspectionId: props.userId,
            nameUser: 'Integração',
            message: historyMessage,
            companyPersonId: undefined,
          })
        );
      } else {
        console.warn('[PowerOffButton.confirmLeaveSession] userId não informado; histórico Hub ignorado.');
      }

      const historyResults = await Promise.allSettled(historyWrites);
      historyResults.forEach((result) => {
        if (result.status === 'rejected') {
          console.warn('[PowerOffButton.confirmLeaveSession] Falha ao registrar histórico.', result.reason);
        }
      });

      // Comentado para NÃO encerrar a vistoria
      // await completeToken(props.publisher.session.sessionId);
      
      props.publisher.session.signal({
        data: Roles.Insured,
        type: 'user-left', 
      });

      // Desconecta apenas o fluxo de vídeo do segurado
      props.publisher.session.disconnect();
    } catch (error) {
      console.warn(error);
    }

    // Navega para o feedback levando os IDs para permitir o botão de retorno
    navigate('/feedback', { 
      state: { 
        sessionId: props.sessionId,
        insuranceId: props.insuranceId,
        userId: props.userId 
      } 
    });
  }

  function cancelLeaveSession() {
    setIsOpenDialog(false);
  }

  return (
    <>
      {isOpenDialog ? (
        <ModalDialogComponent
          isOpenDialog={isOpenDialog}
          confirmLeaveSession={confirmLeaveSession}
          cancelLeaveSession={cancelLeaveSession}
        />
      ) : (
        <></>
      )}
      <CallEnd
        color="success"
        id="navLeaveButton"
        sx={{
          color: 'white',
          fontSize: 25,
          borderRadius: 10,
          padding: 2,
          backgroundColor: 'rgba(255, 0, 0, 0.5)',
        }}
        onClick={() => setIsOpenDialog(true)}
      />
    </>
  );
}
